module.exports = "/virtual-football-league/img/amblems/left/logos/FakeSheffield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeSheffield.png
// module id = 2073
// module chunks = 4